import {
  About,
  Faq,
  FeatureImage,
  Hero,
  HomeFooter,
  HomeHeader,
  Method,
  Personalized,
  Philosophy,
  PrimaryCta,
  Qualifications,
  Testimonials,
} from "../components/home";
import { siteSettings } from "../content/siteContent";
import "../styles/home.css";

export default function Home() {
  return (
    <div className="home-page">
      <a className="home-skip-link" href="#home-main-content">
        Saltar al contenido
      </a>
      <HomeHeader />
      <main id="home-main-content">
        <Hero />
        <Method />
        <Personalized />
        <FeatureImage />
        <About />
        <Philosophy />
        {siteSettings.showTestimonials ? <Testimonials /> : null}
        <Faq />
        <Qualifications />
        <PrimaryCta />
      </main>
      <HomeFooter />
    </div>
  );
}
